import React, { FC } from 'react';
import { Connect, PropsFromRedux } from './SearchResultLegislationsContainer';
import {
  buildUrlWithParameters,
  getParametersFromUrl,
} from '../../../../utils/url-utils/urlUtils';
import { doctrineAnalytics } from '../../../../utils/analyticsUtils';
import { LegislationHit } from '../../../search.types';
import { useRestrictedModal } from '../../../../components/modal/useRestrictedModal';
import { useUser } from '../../../../user/useUser';
import { SearchResultLegislationExcerpt } from './SearchResultLegislationExcerpt';

type Props = {
  legislations: LegislationHit[];
} & PropsFromRedux;

const RawSearchResultLegislations: FC<Props> = ({
  legislations,
  searchQueryUrl,
  originalQueryKey,
  type,
}) => {
  const { accessPremium } = useUser();
  const { openRestrictedModal } = useRestrictedModal();
  const urlParams = getParametersFromUrl(window.location.search);
  const position: number | null = urlParams.position
    ? parseInt(urlParams.position, 10)
    : null;

  const handleResultClicked = (legislation: LegislationHit, index: number) => (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  ) => {
    if (accessPremium) {
      doctrineAnalytics('Search ResultClicked', {
        type: 'law',
        position: index + 1,
        law_id: legislation.docId,
        url: legislation.url,
        reportOriginalQueryKey: true,
      });
    } else {
      event.preventDefault();
      openRestrictedModal({ source: 'excerpt_results_law' });
    }
  };

  return (
    <>
      {legislations.map((legislation: LegislationHit, index: number) => {
        const searchParams = buildUrlWithParameters(legislation.url, {
          original_query_key: originalQueryKey,
          source: 'search_hit',
          position: index + 1,
        });
        const legislationUrl = `${searchParams}&${searchQueryUrl}`;
        return (
          <SearchResultLegislationExcerpt
            legislation={legislation}
            position={position}
            index={index}
            legislationUrl={legislationUrl}
            handleResultClicked={handleResultClicked}
            type={type}
            sources={{
              hits: 'excerpt_results',
              commentaries: 'legislation-results',
            }}
            key={legislation.docId}
          />
        );
      })}
    </>
  );
};

export const SearchResultLegislations = Connect(RawSearchResultLegislations);
